import User_SectionOne from "./User_SectionOne";

function Profile() {
  return (
    <>
      <main>
        <User_SectionOne />
      </main>
    </>
  );
}

export default Profile;
